import { render, staticRenderFns } from "./RemindConfig.vue?vue&type=template&id=0f2b2bf8&scoped=true&"
import script from "./RemindConfig.vue?vue&type=script&lang=js&"
export * from "./RemindConfig.vue?vue&type=script&lang=js&"
import style0 from "./RemindConfig.vue?vue&type=style&index=0&id=0f2b2bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b2bf8",
  null
  
)

export default component.exports